export { default as Badge } from './badge'
export type { Props as BadgeProps, BadgeStatus } from './badge'
